<template>
    <div class="sidebar">
      <ul class="nav-list">
        <li>
            <router-link to="/dashboard">
              <i class="bx bx-grid-alt"></i>
              <span class="links_name">Главная</span>
            </router-link>
            <span class="tooltip">Главная</span>
        </li>

        <li>
          <router-link to="/agents">
            <i class="bx bx-group"></i>
            <span class="links_name">Агенты</span>
          </router-link>
          <span class="tooltip">Агенты</span>
          <b-collapse id="collapse-4" v-model="visible">
            <ul class="child-block">
              <li class="child_item">
                <router-link to="/agents"
                  >Агенты</router-link
                >
              </li>
              <li class="child_item">
                <router-link to="/agent-settlements"
                  >Взаиморасчеты с агентами</router-link
                >
              </li>
              <li class="child_item">
                <router-link to="/useful-materials">
                  Материалы
                </router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li>
            <hr />
        </li>
        <li>
          <router-link to="/profile">
            <i class="bx bx-user"></i>
            <span class="links_name">Мой профиль</span>
          </router-link>
          <span class="tooltip">Мой профиль</span>
        </li>
      </ul>
      <div class="tsoft-active-section">
        <span>{{ handlerActivePageName() }}</span>
      </div>
      <div class="tsoft-sidebar-button">
        <i class="bx bx-menu" id="btn" @click="handlerOpenOrCloseMenu"></i>
      </div>
      <div class="app-version" v-if="visible">
        <span class="version-text">Версия: {{ appVersion }}</span>
      </div>
    </div>
  </template>
  
  <script>
  import { API_USERS_LISTS } from "@/constants";
  import { mapGetters } from "vuex";
  
  const SERVICES_ID_TO_NAMES = {
    22: "to",
    23: "teo",
    24: "sertifikaciya",
    25: "other",
    75: "pnk", 
    76: "svh", 
    77: "strahovanie"
  };
  const initialNotifications = () => ({
    orders: [],
    to: [],
    teo: [],
    sertifikaciya: [],
    other: [],
    by_creators: {},
  });
  
  export default {
    data() {
      return {
        notificationsLocal: initialNotifications(),
        handlerSidebar: false,
        visible: false,
        internalUsers: [],
      };
    },
    computed: {
      ...mapGetters("auth", ["currentUser", "isAuthenticated"]),
  
      notifications() {
        return this.$store.getters.NOTIFICATIONS;
      },

      appVersion() {
        return window.CLIENT_VERSION || '0.9.112';
      }
    },
    mounted() {
      this.$store.dispatch("GET_NOTIFICATIONS");
      setInterval(() => {
        if (this.isAuthenticated) {
          this.$store.dispatch("GET_NOTIFICATIONS");
        }
      }, 30000);
  
      if (
        this.$store.state.userLocalSettings.interfaceSettings.sidebarMenu ==
        "open"
      ) {
        setTimeout(() => {
          this.handlerOpenOrCloseMenu();
        }, 500);
      }
    },
    watch: {
      notifications(newNotifications) {
        this.distributeNotifications(newNotifications);
      },
  
      visible(value) {
        this.$store.dispatch("userLocalSettings/SET_INTERFACE_SETTINGS", {
          name: "sidebarMenu",
          value: value ? "open" : "",
        });
      },
    },
    methods: {
      handlerOpenOrCloseMenu() {
        let sidebar = document.querySelector(".sidebar");
        let closeBtn = document.querySelector("#btn");
        let activeSection = document.querySelector(".tsoft-active-section");
  
        let menuBtnChange = () => {
          if (sidebar.classList.contains("open")) {
            this.visible = true;
            closeBtn.classList.replace("bx-menu", "bx-menu-alt-right");
          } else {
            this.visible = false;
            closeBtn.classList.replace("bx-menu-alt-right", "bx-menu");
          }
        };
  
        activeSection.classList.toggle("hide");
        sidebar.classList.toggle("open");
  
        menuBtnChange();
      },
      handlerActivePageName() {
        if (this.$route.meta.title) {
          if (this.$route.meta.title == 'Заказы') {
            return "Поставки";
          }
          return this.$route.meta.title;
        }
  
        if (this.$route.meta.services) {
          return this.$route.meta.services[this.$route.params.service_id];
        }
  
        if (this.$route.meta.invoices_type) {
          for (let typeInvoices in this.$route.params) {
            return this.$route.meta.invoices_type[
              this.$route.params[typeInvoices]
            ];
          }
        }
  
        for (let userId in this.internalUsers) {
          if (this.$route.params.user_id == this.internalUsers[userId].id) {
            return "Запросы: " + this.internalUsers[userId].name;
          }
        }
      },
      distributeNotifications(newNotifications = []) {
        this.notificationsLocal = initialNotifications();
  
        this.internalUsers.forEach((user, index) => {
          this.$set(this.notificationsLocal.by_creators, `${user.id}`, []);
        });
  
        newNotifications.forEach((notify) => {
          try {
            if (notify.data && notify.data.parameters && notify.data.parameters.service_id) {
              this.notificationsLocal[
                SERVICES_ID_TO_NAMES[notify.data.parameters.service_id]
              ].push(notify);
            }
            if (notify.data && notify.data.parameters && notify.data.parameters.order_id) {
              this.notificationsLocal["orders"].push(notify);
            }
            if (
              this.internalUsers &&
              this.internalUsers.length > 0 &&
              notify.data.parameters &&
              notify.data.parameters.creator_user_id
            ) {
              let user_id = notify.data.parameters.creator_user_id;
              if (this.notificationsLocal.by_creators[user_id]) {
                this.notificationsLocal.by_creators[user_id].push(notify);
              }
            }
          } catch (error) {
            // console.error(error)
          }
        });
      },
    },
  };
  </script>